/** Lỗi có kiểu để UI phân nhánh rõ ràng (không bắt chuỗi message). */

export class ApiError extends Error {
  readonly status: number;
  readonly code: string;
  readonly retryable: boolean;
  readonly details?: unknown;
  /** Header X-Request-Id của Backend (v3) – ghi vào log khi lỗi để truy vết. */
  readonly requestId?: string;

  constructor(status: number, code: string, message: string, details?: unknown, requestId?: string) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.details = details;
    this.requestId = requestId;
    this.retryable = status >= 500 || status === 429 || status === 408;
  }
}

/** Mất mạng / timeout / máy chủ không phản hồi. */
export class NetworkError extends Error {
  readonly retryable = true;
  constructor(message = 'Không kết nối được máy chủ', options?: { cause?: unknown }) {
    super(message, options);
    this.name = 'NetworkError';
  }
}

/** 401 không thể phục hồi: làm mới phiên thất bại ⇒ phải đăng nhập lại. */
export class SessionExpiredError extends Error {
  constructor() {
    super('Phiên đăng nhập đã hết hạn');
    this.name = 'SessionExpiredError';
  }
}

/** 403: đã đăng nhập nhưng không có quyền với tài nguyên này. */
export class ForbiddenError extends ApiError {
  constructor(code = 'FORBIDDEN', message = 'Bạn không có quyền truy cập nội dung này') {
    super(403, code, message);
    this.name = 'ForbiddenError';
  }
}

export const isAbortError = (e: unknown): boolean => e instanceof DOMException && e.name === 'AbortError';

export const isApiError = (e: unknown, code?: string): e is ApiError =>
  e instanceof ApiError && (code === undefined || e.code === code);

/** Lỗi có nên cho người dùng bấm "Thử lại"? */
export const isRetryable = (e: unknown): boolean =>
  e instanceof NetworkError || (e instanceof ApiError && e.retryable);
